// assets
import {
  Handshake,
  FactCheck,
  Beenhere,
  Groups3,
  CalendarMonth,
  EventAvailable,
  SdStorage,
  TravelExplore,
  Search,
} from "@mui/icons-material";

import { SearchEngineIcon } from "components/icons/sidebarIcons";

// constant
export const icons = {
  Search,
  Handshake,
  FactCheck,
  Beenhere,
  Groups3,
  CalendarMonth,
  EventAvailable,
  SdStorage,
  TravelExplore,
};

const searchEngine = {
  id: "search",
  dataTestId: "searchEngine",
  title: "side_menu.search_engine",
  type: "group",
  roles: [
    "user",
    "subuser",
    "member",
    "supervisor",
    "admin",
    "demo",
    "sales",
    "superadmin",
    "it",
  ],
  collapse: false,
  icon: "Search", //icons.Search,
  children: [
    {
      id: "by-giving-history",
      title: "labels.search_by_giving_history_searchbar_title",
      type: "item",
      url: "search/new?tab=giving-history",
      icon: "Handshake", //icons.Handshake,
      breadcrumbs: false,
      roles: ["accessus"],
      dataTestId: "givingHistory",
    },
    {
      id: "by-keyword",
      title: "side_menu.by_keyword",
      type: "item",
      url: "search/new?tab=keywords",
      icon: "FactCheck", //icons.FactCheck,
      breadcrumbs: false,
      roles: ["accessus"],
      tooltip: "tooltips.by_keyword",
    },
    {
      id: "by-name",
      title: "side_menu.by_funder_name",
      type: "item",
      url: "search/new?tab=name",
      icon: "Beenhere", //icons.Beenhere,
      breadcrumbs: false,
      roles: ["accessus"],
      tooltip: "tooltips.by_name",
    },
    {
      id: "by-director",
      title: "side_menu.by_director",
      type: "item",
      url: "search/new?tab=director",
      icon: "Groups3", //icons.Groups3,
      breadcrumbs: false,
      roles: ["accessus"],
      tooltip: "tooltips.by_director",
    },
    {
      id: "by-year",
      title: "side_menu.by_year",
      type: "item",
      url: "search/new?tab=year",
      icon: "CalendarMonth", //icons.CalendarMonth,
      breadcrumbs: false,
      roles: ["accessus"],
      tooltip: "tooltips.by_year",
    },
    /* {
            id: 'by-deadline',
            title: 'side_menu.by_deadline',
            type: 'item',
            url: 'search/by-deadline',
            icon: 'EventAvailable', //icons.EventAvailable,
            breadcrumbs: false,
            roles: ['accessus'],
        }, */
    /*{
            id: 'by-rating',
            title: 'side_menu.by_rating',
            type: 'item',
            url: 'search/by-rating',
            icon: icons.IconStars,
            breadcrumbs: false,
            roles: ['user', 'subuser'],
        },*/
    {
      id: "by-giving-history-ca",
      title: "labels.search_by_giving_history_searchbar_title",
      type: "item",
      url: "search/new?tab=giving-history",
      icon: "Handshake", //icons.Handshake,
      breadcrumbs: false,
      roles: ["accesscanada"],
      dataTestId: "givingHistory",
    },
    {
      id: "by-name-ca",
      title: "side_menu.by_funder_name",
      type: "item",
      url: "search/new?tab=name",
      icon: "FactCheck", //icons.FactCheck,
      breadcrumbs: false,
      roles: ["accesscanada"],
      tooltip: "tooltips.by_name",
    },
    {
      id: "by-director-ca",
      title: "side_menu.by_director",
      type: "item",
      url: "search/new?tab=director",
      icon: "Groups3", //icons.Groups3,
      breadcrumbs: false,
      roles: ["accesscanada"],
      tooltip: "tooltips.by_director",
    },
    {
      id: "by-year-ca",
      title: "side_menu.by_year",
      type: "item",
      url: "search/new?tab=year",
      icon: "CalendarMonth", //icons.CalendarMonth,
      breadcrumbs: false,
      roles: ["accesscanada"],
      tooltip: "tooltips.by_year",
    },

    /*{
            id: 'by-rating',
            title: 'side_menu.by_rating',
            type: 'item',
            url: 'search/by-rating',
            icon: icons.IconStars,
            breadcrumbs: false,
            roles: ['user', 'subuser'],
        },*/
    {
      id: "by-custom",
      title: "side_menu.by_custom",
      type: "item",
      url: "search/new?tab=custom",
      icon: "SdStorage", //icons.SdStorage,
      breadcrumbs: false,
      roles: [
        "user",
        "subuser",
        "member",
        "supervisor",
        "admin",
        "demo",
        "sales",
        "superadmin",
        "it",
      ],
      tooltip: "tooltips.by_custom",
    },
    /* {
            id: 'by-custom-profile',
            title: 'side_menu.by_custom_profile',
            type: 'item',
            url: 'search/by-custom-profile',
            icon: 'SdStorage', //icons.SdStorage,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        }, */
    {
      id: "by-international-funding",
      title: "side_menu.by_international_funding",
      type: "item",
      url: "search/new?tab=international-funding",
      icon: "TravelExplore", //icons.TravelExplore,
      breadcrumbs: false,
      roles: ["accesscanada", "pro", "admin", "sales", "superadmin"],
      visible: (userRoles = []) => {
        const isPro = userRoles.some(role => role === "pro");
        const isAccessCanada = userRoles.some(role => role === "accesscanada");
        const isAdmin = userRoles.some(role => ["admin", "sales", "superadmin"].includes(role));

        return (isPro && isAccessCanada) || isAdmin;
      }
    },
  ],
};

export default searchEngine;
